<template>
	<footer class="page-footer pt-3 pb-3">
		<div class="page-footer__content container">
			<div class="row pb-2">
				<div class="col-12 text-center pb-3">
					<h2 class="h5-size fw-normal headlined">Follow Good Hood Music</h2>
					<a
						v-for="sm in socialMedia"
						target="_blank"
						:href="sm.link"
						:class="'sm-icon icon-'+(sm.platform).replace(/\s+/g, '-').toLowerCase()+' text-big'">
					</a>
				</div>
				<div class="col-12 text-center text-small">
					<router-link to="/partner">Partner</router-link> |
					<router-link to="/datenschutz">Datenschutz</router-link> |
					<router-link to="/impressum">Impressum</router-link>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
	export default {
		name: 'PageFooter',
		props: ['socialMedia'],
		data() {
			return {
			}
		}
	}
</script>

<style>
</style>
